import { BusinessUser } from '@models/businesses';
import { LLCToken } from '@models/llc-token';

export interface LlcStateModel {
	// all tokens available
	connectedIds?: string[];

	error: boolean;

	// has it been checked before?
	loaded: boolean;

	// if anything is currently being done
	loading: boolean;
}

export const defaultLlcStateModel: LlcStateModel = {
	connectedIds: [],
	error: false,
	loaded: false,
	loading: true,
};

export interface ConnectedUser extends BusinessUser {
	name: string;
	lenders?: string[];
	canRevoke?: boolean;
}

export enum CONNECTION_STATUS {
	CONNECTING = 'Connecting',
	CONNECTED = 'Connected',
	DISCONNECTED = 'Disconnected',
	ERRORED = 'Errored',
}
